import { tbPalette } from 'styles/colors';

const getMuiDialog = () => ({
  styleOverrides: {
    root: {
      '& .MuiDialog-paper': {
        minWidth: '300px',
        maxWidth: '800px',
        display: 'flex',
        flexDirection: 'column',
      },
      '& .MuiDialogTitle-root': {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        fontSize: '18px !important',
        '& .MuiTypography-root': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        backgroundColor: tbPalette.background.bright,
        paddingInline: '16px',
      },
      '& .MuiDialogContent-root': {
        padding: '24px !important',
        fontSize: '16px',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '150px',
        gap: '24px',
        backgroundColor: tbPalette.background.bright,
        borderBlock: `2px solid ${tbPalette.border.default}`,

        // When there are multiple direct div children, use default background
        '&:has(> div:nth-of-type(2))': {
          backgroundColor: tbPalette.background.default,
          '& > div': {
            backgroundColor: tbPalette.background.bright,
            padding: '16px',
            borderRadius: '8px',
          },
        },
      },
      '& .MuiDialogActions-root': {
        justifyContent: 'flex-end',
        padding: ' 24px',
        '& .MuiButton-root': {},
        backgroundColor: tbPalette.background.bright,
      },
    },
  },
  defaultProps: {
    transitionDuration: 0,
  },
});

export default getMuiDialog;
